import { initialQuery } from '../../../model/constants/initial-query.tsx';
import { SET_QUERY, PATCH_QUERY, type Action } from '../../actions/query/index.tsx';
import type { QueryState } from './types.tsx';

export const initialState: QueryState = initialQuery;

const query = (state: QueryState = initialState, action: Action): QueryState => {
	switch (action.type) {
		case SET_QUERY:
			return action.payload;
		case PATCH_QUERY:
			return {
				...state,
				...action.payload,
				filter: {
					...state.filter,
					...(action.payload.filter ? action.payload.filter : undefined),
				},
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};

export default query;
